import React from 'react';
import PropTypes from 'prop-types';
import { useSetAtom } from 'jotai';
import useSignalR from '../../Services/signalR';
import { notifySMSSentAtom, notifySMSReceivedAtom } from '../../Atoms/HubAtoms';

export default function ChatHubProvider({ channel }) {
  const setNotifySMSSent = useSetAtom(notifySMSSentAtom);
  const setNotifySMSReceived = useSetAtom(notifySMSReceivedAtom);

   
  useSignalR(`${window.databeasy?.API_URL}hubs/chathub`, channel, [
    {
      eventName: 'NotifySMSSent',
      callback: (message) => {
        setNotifySMSSent(message);
      },
    },
    {
      eventName: 'NotifySMSReceived',
      callback: (message) => {
        setNotifySMSReceived(message);
      },
    },
  ]);

  return <div />;
}

ChatHubProvider.propTypes = {
  channel: PropTypes.string.isRequired,
};
